import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ resource, project, filter, size, page }) =>
    present(
      repository
        .getOptimizedTimeSheet(resource, project, filter, size, page)
        .then((timeSheet) => ({
          resource,
          project,
          filter,
          size,
          page,
          timeSheet,
        }))
        .catch(() => Promise.reject({ resource, project, filter, size, page })),
    );
}

export type { Interactor };

export { createInteractor };
